<script>
  export default {
    props: {
      value: {
        type: Number,
        required: true,
      },

      around: {
        type: Boolean,
        required: false,
        default: false,
      },

      items: {
        type: Array,
        required: true,
        validate: array => array.every(item => typeof item === 'string'),
      },
    },

    watch: {
      value: 'update',
    },

    data: () => ({
      left: 0,
      width: 0,
    }),

    computed: {
      border () {
        return {
          left: `${this.left}px`,
          width: `${this.width}px`,
        };
      },
    },

    mounted () {
      this.update(this.value);
    },

    methods: {
      update (index) {
        const el = this.$refs.item[index];

        this.left = el.offsetLeft;
        this.width = el.clientWidth;

        this.$emit('input', index);
      },
    },
  };
</script>

<template>
  <header class="card-tab card__header">
    <nav class="card-tab__nav">
      <ul
        class="card-tab__list"
        :class="{ 'card-tab__list--around': around }"
        >
        <li
          ref="item"
          :key="item"
          class="card-tab__item"
          v-for="(item, index) in items"
          :class="{ 'card-tab__item--active': value === index }"
          >
          <a
            href="#"
            @click.prevent="update(index)"
            class="card-tab__item-link"
            >
            {{ item }}
          </a>
        </li>
      </ul>

      <span
        :style="border"
        class="card-tab__border"
        >
      </span>
    </nav>
  </header>
</template>

<style lang="scss">
  .card-tab {
    padding-top: 0;
    line-height: 1;
    color: #b2b8c5;
    padding-bottom: 0;

    &__nav {
      flex: 1;
      position: relative;
    }

    &__list {
      display: flex;

      &--around {
        justify-content: space-around;
      }
    }

    &__border {
      bottom: -2px;
      height: 2px;
      transition: 250ms;
      position: absolute;
    }

    &__item {
      margin-right: 45px;

      &--active &-link {
        color: #fff;
      }

      &-link {
        height: 53px;
        display: flex;
        transition: 250ms;
        position: relative;
        padding-bottom: 12px;
        align-items: flex-end;
        justify-content: center;

        &:hover {
          color: rgba(255, 255, 255, 0.85);
        }
      }
    }
  }
</style>
